import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const TransportRules = () => {
    useEffect(() => {
        document.title = 'Transport Rules -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> The Almanac  </li>
                 <li>School Rules</li>
                 <li>Transport Rules</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Transport Rules </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                      <p>There are two school owned buses. Additionally, the school hires private buses to help students commute. In order to ensure the safety of their wards, parents are advised to use school/school hired buses.</p>
                    <ul className="list"> 
                    <li> Bus routes are fixed at the beginning of the academic session. Please do not request for a change of route in the mid-session.
                    </li>
                    <li> Discontinuation of  bus  during  mid  of  the  academic session will not be permitted except under extreme circumstances & with prior approval of Principal. The bus fee is to be paid for entire month even if the bus has been used only for a day in a month. There is no system of one way charge.
                    </li>
                    <li> A Bus Pass will be issued every year. In case of loss a duplicate Pass will be issued for Rs. 20/- . The student must carry the Bus Pass at all times.
                    </li>
                    <li> The bus facility is provided on a 'No Profit, No Loss' basis. A sufficient number of students is required to make it a feasible venture. Hence bus facilities cannot be claimed as a right by any parent.
                    </li>
                    <li> Students will not be permitted to board the bus or alight from it at any point other than the authorized boarding point.
                    </li>
                    <li> Students involved in acts  of   indiscipline, especially those affecting the safety and well-being of other students will be debarred from using the bus.
                    </li>
                    <li> Measures of all kinds will be taken for the safety of students using the school bus. However the school cannot be held responsible for any accident, injury or loss of life. In case the school/school hired buses are not used for commuting, parents must ensure that only government authorized/legal modes of transportation are used.
                    </li>
                    <li> For all queries related to school transport, parents are requested to contact Estate Superintendent (ES), who is a single point of contact. The particulars of the ES is  available on school website. </li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default TransportRules